import { render, staticRenderFns } from "./GrantAddress.vue?vue&type=template&id=040d964b"
import script from "./GrantAddress.vue?vue&type=script&lang=js"
export * from "./GrantAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports